{"id":"CurrencySelect","prefabs":{"default":{"children":[{"component":"CurrencySelect","options":"options:*"}]}}}